module.exports = __webpack_public_path__ + "images/aab1701f2772359a395aefc0c20f19ae.png";